{
  "replaceMessage": "Απόθεση αρχείου για αντικατάσταση"
}
